import React, { useEffect, useState } from "react";
import { Box, Text, Pressable } from "native-base";
import { COLORS } from "../../utils/colors";

const Stars = ({
  editable = true,
  stars = 0,
  size = "xl",
  onChange = () => {},
}) => {
  const [value, setValue] = useState(0);

  useEffect(() => {
    setValue(stars);
  }, [stars]);

  const handleStarClick = (starValue) => {
    if (value === starValue) {
      setValue(0);
    } else {
      setValue(starValue);
    }
    if (onChange) {
      if (value === starValue) {
        onChange("");
      } else {
        onChange(starValue);
      }
    }
  };

  const renderStars = () => {
    const stars = [];

    for (let i = 1; i <= 5; i++) {
      stars.push(
        editable ? (
          <Pressable key={i} onPress={() => editable && handleStarClick(i)}>
            <Box marginRight={1}>
              <Text
                fontSize={size}
                color={
                  i <= value ? COLORS.RATINGS_COLOR : COLORS.REVIEW_BACK_COLOR
                }
              >
                ★
              </Text>
            </Box>
          </Pressable>
        ) : (
          <Box>
            <Text
              fontSize={size}
              color={
                i <= value ? COLORS.RATINGS_COLOR : COLORS.REVIEW_BACK_COLOR
              }
            >
              ★
            </Text>
          </Box>
        )
      );
    }

    return stars;
  };

  return <Box flexDirection="row">{renderStars()}</Box>;
};

export default Stars;
